'use es6';

import { BaseResponsiveRowToolbar, buildActionsForRow } from './BaseResponsiveRowToolbar';

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 * @param {boolean} props.isInDeveloperMode (optional)
 */
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileRowToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveRowToolbar, {
    active: false,
    actions: buildActionsForRow({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode
    }),
    responsiveSize: responsiveSize
  });
};

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 * @param {boolean} props.isInDeveloperMode (optional)
 */
const MockResponsiveMobileRowToolbarWithHideIconToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveRowToolbar, {
    active: false,
    actions: buildActionsForRow({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode,
      canToggleRowVisibility: true
    }),
    responsiveSize: responsiveSize
  });
};

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 * @param {boolean} props.isInDeveloperMode (optional)
 */
const MockResponsiveDesktopRowToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveRowToolbar, {
    active: false,
    actions: buildActionsForRow({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode
    }),
    responsiveSize: responsiveSize
  });
};
export { MockResponsiveMobileRowToolbarToMeasure, MockResponsiveMobileRowToolbarWithHideIconToMeasure, MockResponsiveDesktopRowToolbarToMeasure };